module.exports = {"id":"187052","name":"Yann M'Vila","rating":"78","photo":"./data/images/photos/2/187052.png","club":{"name":"ASSE","logo":"./data/images/clubs/ASSE.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YannM'Vila0.json
// module id = 4383
// module chunks = 0